import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteProgressionConfiguration = ({
    isOpen,
    onClose,
    onConfirm,
    configurationName,
}) => {
    const bodyMessage = `
        Are you sure you want to delete
        <strong>${configurationName}</strong>?
        This action cannot be undone.
    `;

    return (
        <ReusableModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Confirm Delete"
            bodyMessage={
                <div
                    dangerouslySetInnerHTML={{
                        __html: bodyMessage,
                    }}
                />
            }
            confirmLabel="Confirm"
            cancelLabel="Cancel"
        />
    );
};

export default DeleteProgressionConfiguration;